import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useReactiveVar } from "@apollo/client";
import { authVar } from "../ReactiveVariables";

export default function RouteWrapper({ element, isPrivate, isAuthPage, admin, type, ...rest }) {
  // Define public paths and current path
  const publicPaths = ["/", "/login", "/admin", "/customerlogin", "/register"];
  const currentPath = window.location.pathname;
  const authStatus = useReactiveVar(authVar);
  const { loaded, auth } = authStatus;
  if (loaded && !auth && !publicPaths.includes(currentPath)) {
    return (
      <Navigate
        to={{
          pathname: "/login",
          state: { url: currentPath },
        }}
        replace
      />
    );
  }
  return <Outlet {...rest} element={element} />;
}
